var uniqueProdNamesArray = [];

collectionGetVariations = function(filteredDataProducts) {
	var variantPrice = [];
	var variantCompareAtPrice = [];

	var prodsWithVariants = [];

	var newlyLoadedProdsWithVariants = [];

    var newlyLoadedProdsHtml;
    
    var productClass = ".product-col";
    var productPriceClass = ".product-price";

    var swatchContainerClass = ".product-color-swatches";

	var pageProducts = $(productClass);

	var filteredDuplicateProducts = [];

	var quickShopObj = {};

	var lowestPrice;
	var highestPrice;
	var highestCompareAtPrice;

	var allPrices = [];
	var allCompareAtPrices = [];

	var variantsPriceRanges = false;
	var variantsSamePrices = false;

	var htmlOutput = '';

	var percentOff;

	var htmlSaleLabel = '<p class="product-sale-tag">on sale</p>';

	var currentProductPrice = '';
	var currentProductCompareAtPrice = '';

	if (filteredDataProducts) {
		pageProducts = $(filteredDataProducts).filter(productClass);
	}


	function checkArrValueSameness(array){
		return !array.some(function(value, index, array){
			return value !== array[0];
		});
	}

	function saleHtmlOutput(compareAtPrice, price, percentOff, hasPriceDifference) {
		var upToLabel = hasPriceDifference ? 'Up to ' : '';
		var selectColoursLabel = hasPriceDifference ? '<p>select colours</p>' : '';

		return "<p><s>"+theme.Currency.formatMoney(compareAtPrice)+"</s> "+theme.Currency.formatMoney(price)+"</p>"+ selectColoursLabel+"<p class='pt-1 price-sale-percent'>"+upToLabel+percentOff+"% off</p>"
	}


	function checkIfSale(mainProd) {
       
		lowestPrice = 0;
		highestPrice = 0;
		highestCompareAtPrice = 0;

		allPrices = [];
		allCompareAtPrices = [];

		variantsPriceRanges = false;
		variantsSamePrices = false;

		htmlOutput = '';

		percentOff = 0;

		currentProductPrice = $(mainProd).eq(0).find(productPriceClass).data('price');
		currentProductCompareAtPrice = $(mainProd).eq(0).find(productPriceClass).data('compareAtPrice');

		allPrices.push(currentProductPrice);

		if(currentProductCompareAtPrice > 0) {
			allCompareAtPrices.push(currentProductCompareAtPrice);
		}

		$(mainProd).eq(0).find('.variant-price').each(function(){
          
			if($(this).data('variantPrice') > 0){
				allPrices.push($(this).data('variantPrice'));
			}
		});


		$(mainProd).eq(0).find('.variant-compare-at-price').each(function(){
			if($(this).data('variantCompareAtPrice') > 0) {
				allCompareAtPrices.push($(this).data('variantCompareAtPrice'));
			}
		});
      
      	

		if(allPrices.length > 0) {
			lowestPrice = Math.min.apply(Math, allPrices);

			highestPrice = Math.max.apply(Math, allPrices);
		}

		if(allCompareAtPrices.length > 0){
			highestCompareAtPrice = Math.max.apply(Math, allCompareAtPrices);
		}


		if (highestCompareAtPrice > 0) {
			var arePricesTheSame = checkArrValueSameness(allPrices);

			if(arePricesTheSame !== true) {
				percentOff = Math.round((highestCompareAtPrice - lowestPrice) * 100 / highestCompareAtPrice);
				
				var priceWrapper = $(mainProd).eq(0).find(".product-price .product-price-wrapper");

				if(priceWrapper.find(".price-select-colors").length === 0) {
					if(priceWrapper.find(".price-sale-percent").length === 0) {
						priceWrapper.append(`<p class="pt-1 price-sale-percent"></p>`);
					}
					priceWrapper.find(".price-sale-percent").text(`Up to ${percentOff}% off`);
					priceWrapper.find(".product-price-amount").after(`<p class='price-select-colors'>select colours</p>`)
				}
			}
		}
	}

	function getColourSwatch(p, currentMainProduct, currentMainProductName) {
		var hex = '';

		for(var tag = 0; tag < p.tags.length; tag++) {
			if(p.tags[tag].indexOf("#") > -1) {
				hex = p.tags[tag];
				break;
			}
		}
		if(hex != '') {
			$(currentMainProduct).find(swatchContainerClass).append("<button class='swatch swatch-"+ p.handle + "' data-swatch-variant-price='"+p.price+"' data-swatch-variant-compare-at-price='"+p.compare_at_price+"'>" + "<span class='sr-only'>" + p.title.trim() + "</span>" + "<img src=" + window.slate.Image.getSizedImageUrl(p.featured_image, '40x') + " />" + " </button>\n\r");
		}

	}

	function getPrices(p, currentMainProduct, currentMainProductName){
		$(currentMainProduct).find(".variant-prices").append("<div class='variant-price' data-variant-price='"+p.price+"'> </div> <div class='variant-compare-at-price' data-variant-compare-at-price='"+p.compare_at_price+"'> </div>");

	}

	function getFeaturedImage(p, currentMainProduct) {
		var secondImage = p.media[1] && p.media[1].media_type === 'image' ? p.media[1] : p.media[0];
		if(p.featured_image != null) {
			$(currentMainProduct).find(".collection-product-images").append("<div class='collection-product-image product-image-swatch image-"+p.handle+"'><a href='"+ p.url +"' class='collection-product-image-link'><img class='image-top' src='"+window.slate.Image.getSizedImageUrl(p.featured_image, '480x480') +"' alt='"+p.featured_image.alt+"' /><img class='image-bottom' src='"+window.slate.Image.getSizedImageUrl(secondImage.src, '480x480') +"' alt='"+secondImage.alt+"' /></a></div>\n\r");
		}
	}

	function ajaxGetInfo(productColourHandlesArray, currentMainProduct, currentMainProductName, index) {
		var colourHandleName = '';


		jQuery.getJSON('/products/'+productColourHandlesArray+'.js', function(p) {
			if(p.available == true) {
				colourHandleName = productColourHandlesArray;

				getColourSwatch(p, currentMainProduct, currentMainProductName);

				getFeaturedImage(p, currentMainProduct, currentMainProductName);

				getPrices(p, currentMainProduct, currentMainProductName);

				var indexCount = parseInt(index) + 1;

				quickShopObj[currentMainProductName]['colours'][indexCount] = colourHandleName;

				if(prodsWithVariants.indexOf(currentMainProductName) === -1) {
					prodsWithVariants.push(currentMainProductName);
				}

			}
		});
	}

	function checkForDuplicates(){
		$(pageProducts).each(function(){
			var addProdName = $(this).data('prod-name');
			if(uniqueProdNamesArray.indexOf(addProdName) > -1) {
				$(this).remove();
			}
			else {
				uniqueProdNamesArray.push(addProdName);
				filteredDuplicateProducts.push(this);
			}
		});
	}

	var availableHandles = [];

	function getVariantInfo() {

		if(filteredDuplicateProducts.length > 0){
			pageProducts = filteredDuplicateProducts;
		}

		$(pageProducts).each(function(){
			var currentMainProductName = $(this).data('prod-name');

			var productInfo = $(this).data('product-info');
			var currentMainProduct = $(this);

			var productColourHandles = $(this).attr("data-product-other-colour-handles");

			var currentMainProdPrice = $(this).find(".product-price").data('price');
			var currentMainProdCompareAtPrice = $(this).find(".product-price").data('compare-at-price');


			if(productColourHandles) {
				productColourHandlesArray = $.trim(productColourHandles).split(" ");
			}
			else {
				productColourHandlesArray = [];
			}

			variantHandles = [];

			availableHandles = [];

			quickShopObj[currentMainProductName] = {};
			quickShopObj[currentMainProductName].name = currentMainProductName;
			quickShopObj[currentMainProductName].colours = {};
			quickShopObj[currentMainProductName]['colours'][0] = productInfo;

			if(productColourHandlesArray.length > 0) {
				for(var i = 0; i < productColourHandlesArray.length; i++) {

					if(productInfo !== productColourHandlesArray[i]) {
						ajaxGetInfo(productColourHandlesArray[i], currentMainProduct, currentMainProductName, i);
					}

				}

			}



		})
	}

	function updateQuickShopDataAttr() {
		for(var colour in quickShopObj) {
			var handleStr = '';
			var prodName = quickShopObj[colour].name;

			var colHandlesArr = Object.values(quickShopObj[colour].colours);

			for(var j = 0; j < colHandlesArr.length; j++){
				handleStr += colHandlesArr[j] + " ";
			}

			handleStr = $.trim(handleStr);

			$('[data-prod-name="'+prodName+'"]').find('.quick-shop').attr('data-product-other-colour-handles', handleStr);
		}
	}

	function update() {
		setTimeout(function(){
			for(var j = 0; j < prodsWithVariants.length; j++) {
				$('[data-prod-name="'+prodsWithVariants[j]+'"]').each(function() {
					checkIfSale($(this));
				})
			}

			// updateQuickShopDataAttr();

			$(".swatch").click(function(){
              var parentProduct = $(this).closest(productClass);
              
				parentProduct.find(".swatch").removeClass("swatch-active");
				$(this).addClass("swatch-active");
				var swatchName = $(this).attr('class').split(' ')[1];

				var colorName = swatchName.replace('swatch-', '');
				var currentSwatch = '.' + $(this).attr('class').split(' ')[1];
				var imageContainer = '';
				var findImage = '.image-' + colorName;

				var variantLink = parentProduct.find(findImage).find(".collection-product-image-link").attr('href');

				parentProduct.find(".product-image-swatch").css("z-index", "-1");

				parentProduct.find(findImage).css("z-index", "2");
				parentProduct.find(".product-block-name").attr('href', variantLink);
              
              	var swatchPrice = $(this).data('swatchVariantPrice');
				var swatchCompareAtPrice = $(this).data('swatchVariantCompareAtPrice');
              
              if(swatchCompareAtPrice > swatchPrice) {
					parentProduct.find(".product-price-wrapper .product-price-amount s").show();
					parentProduct.find(".product-price-wrapper .product-price-amount s").text(theme.Currency.formatMoney(swatchCompareAtPrice));
					parentProduct.find(".product-price-wrapper .product-price-amount span").text(theme.Currency.formatMoney(swatchPrice));
				} else if (swatchPrice) {
					parentProduct.find(".product-price-wrapper .product-price-amount s").hide();
					parentProduct.find(".product-price-wrapper .product-price-amount s").text(null);
					parentProduct.find(".product-price-wrapper .product-price-amount span").text(theme.Currency.formatMoney(swatchPrice));
				}
				
			});
		}, 1000);
	}

	$(document).ajaxStop(function () {
		update();
		
	});

	update();

// 	checkForDuplicates();


	getVariantInfo();

};
